module.exports = __webpack_public_path__ + "static/media/login_logo_new.771c18ae.png";